import { useState } from "react";

export default function Navbar({ setSwap, swap,tab,setTab }) {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const sortBy = (option) => {
    setIsPopupVisible(false); // Close popup after selection
};
  return (
    <>
      <div className="p-4 mx-auto max-w-lg s px-2">
        <nav className="bg-transparent">
          <div className="max-w-screen-xl flex  items-center justify-between ">

           <div className="flex gap-4 lg md:text-2xl">
            <p onClick={() => setTab("swap")} className={`${tab =="swap"?"cursor-pointer text-white":"text-[#5A5B56]"}  ${tab == "swap"&&"border border-b-2 border-l-0 border-r-0 border-t-0 swap  border-b-[#C4FE48]"}`}>Swap</p>
            <p onClick={() => setTab("limit")} className={`${tab =="limit"?"cursor-pointer text-white":"text-[#5A5B56]"}  ${tab == "limit" && "border border-b-2 border-l-0 border-r-0 border-t-0 border-b-[#C4FE48]"}`}>Limit</p>

           </div>
            <div className="flex ">
             
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}
